import type { ReactNode } from 'react';

export const symbol_mobile_block: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24 18-42t42-18h438q24.75 0 42.38 17.62Q758-884.75 758-860v150q18 3 30 16.95 12 13.96 12 31.63V-587q0 19-12 33t-30 17v437q0 24.75-17.62 42.37Q722.75-40 698-40H260Zm0-60h438v-760H260v760Zm0 0v-760 760Zm219-220q66 0 113-47t47-113q0-66-47-113t-113-47q-66 0-113 47t-47 113q0 66 47 113t113 47Zm0-50q-46.2 0-78.1-32.5Q369-435 369-481q0-15.09 4.5-29.54Q378-525 386-538l151 151q-12 9-27.11 13-15.12 4-30.89 4Zm94-52L421-574q12-8 27.11-12 15.12-4 30.89-4 46.2 0 78.1 31.9Q589-526.2 589-480q0 15.43-4 30.21Q581-435 573-422Z"
		/>
	</svg>
);
